import { render, staticRenderFns } from "./TicketAdd.vue?vue&type=template&id=4fd3d35c&scoped=true"
import script from "./TicketAdd.vue?vue&type=script&lang=ts"
export * from "./TicketAdd.vue?vue&type=script&lang=ts"
import style0 from "./TicketAdd.vue?vue&type=style&index=0&id=4fd3d35c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd3d35c",
  null
  
)

export default component.exports